import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { AdminService } from '../admin.service';
import { Flow, FeatureFlow } from '../../shared/models/Flow';
import { ManageVehicleService } from '../manage-vehicle/manage-vehicle.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import * as _ from 'lodash';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { Observable } from 'rxjs';
import { AlertModelComponent } from '../../shared/components/alert-model/alert-model.component';

@Component({
  selector: 'app-manage-mapping',
  templateUrl: './manage-mapping.component.html',
  styleUrls: ['./manage-mapping.component.scss']
})
export class ManageMappingComponent implements OnInit {
  public features: FeatureFlow[] = [];
  public selectedFeatureType = 'internal';
  public selectedFeature: FeatureFlow = <FeatureFlow> {};
  public yearList = [];
  public generationList = [];
  public generationListOriginal = [];
  public yearListOriginal = [];
  public vehicles: any;
  public generationFilter: any;
  public vehiclesList: any = [];
  public displayedColumns: string[] = [];
  public vehicleDataSource = new MatTableDataSource([]);
  public mappedModels = [];
  public existingMappedModels = [];
  public selectedGeneration: string;
  public isEdit = false;
  public unmappedModels = [];
  public mapping: boolean;
  selection = new SelectionModel<any>(true, []);
  public isSelectAll: boolean;
  public alerts: any[] = [];
  public compatibleLegend = [];
  public searchValue = '';
  public mappedCount = 0;
  public showExisting = false;
  public copySelectedFeatureType: string;
  public copyFeatures: FeatureFlow[] = [];
  public copySelectedFeature: FeatureFlow = <FeatureFlow> {};
  public copyVehiclesList: any = [];
  public copyExisting = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private adminService: AdminService, private vehicleService: ManageVehicleService, private dialog: MatDialog) {
    this.displayedColumns = ['select', 'model', 'year'];
  }

  ngOnInit() {
    this.selectedFeature.controls = [];
    this.featureTypeChange();
    this.getAllVehicles();
    this.compatibleLegend = [
      { name: 'Mapped models', value: 'fa fa-circle color-map' },
      { name: 'Unmapped Models', value: 'fa fa-circle color-unmap' }];
  }

  /* Getting list of features based on Feature type change */
  featureTypeChange() {
    this.alerts = [];
    this.searchValue = '';
    this.applyFilter(this.searchValue);
    this.isSelectAll = false;
    this.ResetCopyExisting();
    this.adminService.getFlow(this.selectedFeatureType, this.adminService.selectedApplication).subscribe(data => {
      this.features = data;
      this.selectedFeature = <FeatureFlow> {};
      this.selectedGeneration = null;
      this.vehicleDataSource.data = [];
    });
  }

  /* Getting list of genertaion based on Feature change */
  featureChange() {
    this.alerts = [];
    this.searchValue = '';
    this.applyFilter(this.searchValue);
    this.ResetCopyExisting();
    this.isSelectAll = false;
    this.getVehiclesByFeature();
    this.selectedGeneration = null;
    this.vehicleDataSource.data = [];
  }

  /* Getting list of vehicles and generations */
  getAllVehicles() {
    this.vehicleService.getAllVehicle().subscribe((data: any) => {
      this.vehicles = data;
      data.forEach((dataobj, index) => {
        this.yearList = data.map(x => x.years);
      });
      this.yearList.forEach((dataobj, index) => {
        this.yearList[index].forEach((dataobj, index) => {
          this.yearListOriginal.push(dataobj.year);
          if (dataobj.generation !== null || dataobj.generation !== '') {
            this.generationListOriginal.push(dataobj.generation);
          }
        });
      });
      this.generationList = this.generationListOriginal.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return (elem);
        }
      });
      this.generationList.sort((a, b) => {
        return a.localeCompare(b, 'en', { 'sensitivity': 'base' });
      });
    });
  }

  loadGridData(event: any) {
    this.searchValue = '';
    this.isSelectAll = false;
    this.isEdit = false;
    this.selectedGeneration = event;
    this.generationFilter = [];
    this.vehicleDataSource.data = [];
    this.vehicles
      .filter(x => x.years
        .some(y => y.generation === event))
      .map(x => {
        const n = Object.assign({}, x, {
          years: x.years.filter(
            years => years.generation === event)
        });
        if (n) {
          this.generationFilter.push(n);
        }
      });
    this.mappedCount = 0;
    this.vehicles
      .map(x => {
        x.years.map(y => {
          if (y.features.indexOf(this.selectedFeature.issueId) > -1 && y.generation) {
            this.mappedCount = this.mappedCount + 1;
          }
        });
      });
    this.generationFilter.forEach(element => {
      element.years.forEach(element2 => {
        const vehicle: any = {};
        vehicle['mapped'] = false;
        const filter = this.vehiclesList;
        filter.filter(x => x.model === element.model);
        filter
          .filter(x => x.model === element.model && x.years
            .some(y => y.year === element2.year)).map(x => {
              x.years.map(y => {
                if (y.year === element2.year && y.features.indexOf(this.selectedFeature.issueId) > -1) {
                  vehicle['mapped'] = true;
                }
              });
            });
        vehicle['model'] = element.model;
        vehicle['year'] = element2.year;
        this.vehicleDataSource.data.push(vehicle);
      });
    });
    this.vehicleDataSource.data = this.vehicleDataSource.data.sort((obj1, obj2) =>
      obj1.mapped > obj2.mapped ? -1 : 1);
    this.mappedModels = this.vehicleDataSource.data.filter(x => x.mapped === true);
    this.unmappedModels = this.vehicleDataSource.data.filter(x => x.mapped === false);
    setTimeout(() => {
      this.vehicleDataSource.sort = this.sort;
      this.vehicleDataSource.paginator = this.paginator;
    });
  }

  /* Loading grid data based on generation change */
  generationChange(event: any) {
    if (_.isUndefined(this.copySelectedFeature.issueId)) {
      this.loadGridData(event);
    } else {
      this.CopyMappedModels();
    }
  }

  /* Method to unmap models */
  unmappingModels() {
    this.isEdit = true;
    this.mapping = false;
    this.isSelectAll = false;
    this.vehicleDataSource.data = this.mappedModels;
    this.paginator.firstPage();
  }

  /* Method to map models */
  mappingModels() {
    this.isEdit = true;
    this.mapping = true;
    this.isSelectAll = false;
    this.vehicleDataSource.data = this.unmappedModels;
    this.paginator.firstPage();
  }

  /* Method to cancel edit */
  cancelMapping() {
    this.openConfirmDialog();
  }

  /*Grid Filter */
  applyFilter(filterValue: string) {
    this.vehicleDataSource.filter = filterValue.trim().toLowerCase();
  }

  getVehiclesByFeature() {
    this.vehicleService.getAllVehiclesByFeature(this.selectedFeature.issueId).subscribe((response: any) => {
      this.vehiclesList = response;
      if (this.selectedGeneration) {
        this.generationChange(this.selectedGeneration);
      }
    });
  }

  getAllVehiclesModel() {
    this.vehicleService.getAllVehicle().subscribe((data: any) => {
      this.vehicles = data;
      this.generationChange(this.selectedGeneration);
    });
  }

  /* Method to save mapping */
  saveMapping() {
    let selectedModels = [];
    let unmap: any;
    let map: any;
    if (this.copyExisting) {
      if (this.mappedCount === this.existingMappedModels.length && this.selection.selected.length === 0 &&
        this.selectedFeature.status === 'published') {
        this.openAlertDialog();
      } else {
        unmap = this.updateVehicleInfo(this.existingMappedModels, false);
        map = this.updateVehicleInfo(this.selection.selected, true);
      }
      const data = this.updateExistingMapping(unmap, map);
    } else {
      if (!this.mapping && this.selection.selected.length === this.mappedCount && this.selectedFeature.status === 'published') {
        this.openAlertDialog();
      } else {
        selectedModels = this.updateVehicleInfo(this.selection.selected, this.mapping);
        this.updateFeatureToVehicle(selectedModels);
      }
    }
  }

  public openAlertDialog() {
    const dialogRef = this.dialog.open(AlertModelComponent, {
      width: '350px',
      data: 'Published Support topic should have at least one mapping'
    });
  }

  public updateExistingMapping(vehicles, newMap) {
    this.vehicleService.updateVehicles(vehicles).subscribe((response: any) => {
      if (response) {
        this.getAllVehicles();
        this.updateFeatureToVehicle(newMap);
      }
    });
  }

  /* Method to avoid routing in edit mode */
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    this.alerts = [];
    if (this.isEdit) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: 'All unsaved data will be lost. Do you want to continue?',
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  public updateVehicleInfo(selectedMapping, isMap) {
    const selectedModels = [];
    const filterVehicle = JSON.parse(JSON.stringify(selectedMapping));
    const res = _.groupBy(filterVehicle, 'model');
    for (let ele in res) {
      const x = this.vehicles.filter(x => x.model == ele);
      x.map(vehicleModel => {
        res[ele].forEach(element => {
          const years = _.get(vehicleModel, 'years');
          years.map(modelYear => {
            if (element.year === modelYear.year) {
              const features: Array<string> = _.get(modelYear, 'features');
              if (isMap) {
                features.push(this.selectedFeature.issueId);
              } else if (!isMap) {
                const index: number = features.indexOf(this.selectedFeature.issueId);
                features.splice(index, 1);
              }
              modelYear.features = features;
            }
          });
        });
        selectedModels.push(x);
      });
    }
    return selectedModels;
  }

  public updateFeatureToVehicle(vehicles) {
    this.vehicleService.updateVehicles(vehicles).subscribe((response: any) => {
      if (response) {
        this.isEdit = false;
        this.getVehiclesByFeature();
        this.selection = new SelectionModel<any>(true, []);
        this.isSelectAll = false;
        this.ResetCopyExisting();
        this.showAlertMessages('success', 'The Support topic mapping is saved successfully');
        this.searchValue = '';
        this.applyFilter(this.searchValue);
      }
    });
  }

  selectAll(event) {
    if (event.checked) {
      this.selection = new SelectionModel<any>(true, this.vehicleDataSource.data);
    } else {
      this.selection = new SelectionModel<any>(true, []);
    }
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'All unsaved data will be lost. Do you want to continue?',
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isEdit = false;
        this.vehicleDataSource.data = this.mappedModels.concat(this.unmappedModels);
        this.paginator.firstPage();
        this.selection = new SelectionModel<any>(true, []);
        this.isSelectAll = false;
        this.searchValue = '';
        this.ResetCopyExisting();
        this.applyFilter(this.searchValue);
      }
    });
  }

  showExistingChange() {
    if (!this.showExisting) {
      this.copyExisting = this.showExisting;
      this.generationChange(this.selectedGeneration);
      this.copySelectedFeatureType = '';
      this.copySelectedFeature = <FeatureFlow> {};
    }
  }

  copyFeatureTypeChange() {
    if (this.selectedFeatureType === this.copySelectedFeatureType) {
      this.copyFeatures = JSON.parse(JSON.stringify(this.features));
      this.copyFeatures.splice(this.features.indexOf(this.selectedFeature), 1);
    } else {
      this.adminService.getFlow(this.copySelectedFeatureType, this.adminService.selectedApplication).subscribe(data => {
        this.copyFeatures = data;
      });
    }
  }

  copyExistingMapping() {
    if (this.mappedModels && this.mappedModels.length > 0) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: 'The existing mapping will be overwritten. Continue?',
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.selection = new SelectionModel<any>(true, this.mappedModels);
          this.saveMapping();
        }
      });
    } else {
      this.selection = new SelectionModel<any>(true, this.mappedModels);
      this.saveMapping();
    }
  }

  CopyMappedModels() {
    this.generationFilter = [];
    this.vehicleDataSource.data = [];
    this.vehicles
      .filter(x => x.years
        .some(y => y.generation === this.selectedGeneration))
      .map(x => {
        const n = Object.assign({}, x, {
          years: x.years.filter(
            years => years.generation === this.selectedGeneration)
        });
        if (n) {
          this.generationFilter.push(n);
        }
      });
    this.generationFilter.forEach(element => {
      element.years.forEach(element2 => {
        const vehicle: any = {};
        vehicle['mapped'] = false;
        const filter = this.copyVehiclesList;
        filter.filter(x => x.model === element.model);
        filter
          .filter(x => x.model === element.model && x.years
            .some(y => y.year === element2.year)).map(x => {
              x.years.map(y => {
                if (y.year === element2.year && y.features.indexOf(this.copySelectedFeature.issueId) > -1) {
                  vehicle['mapped'] = true;
                }
              });
            });
        vehicle['model'] = element.model;
        vehicle['year'] = element2.year;
        this.vehicleDataSource.data.push(vehicle);
      });
    });
    this.vehicleDataSource.data = this.vehicleDataSource.data.sort((obj1, obj2) =>
      obj1.mapped > obj2.mapped ? -1 : 1);
    this.existingMappedModels = this.mappedModels;
    this.mappedModels = this.vehicleDataSource.data.filter(x => x.mapped === true);
    this.unmappedModels = this.vehicleDataSource.data.filter(x => x.mapped === false);
    setTimeout(() => {
      this.vehicleDataSource.sort = this.sort;
      this.vehicleDataSource.paginator = this.paginator;
    });
  }

  copyFeatureChange() {
    this.vehicleService.getAllVehiclesByFeature(this.copySelectedFeature.issueId).subscribe((response: any) => {
      this.copyVehiclesList = response;
      this.CopyMappedModels();
      this.copyExisting = true;
    });
  }

  ResetCopyExisting() {
    this.copyExisting = false;
    this.showExisting = false;
    this.copySelectedFeatureType = '';
    this.copySelectedFeature = <FeatureFlow> {};
  }

}
